export const createAuthApi = (customFetch) => ({
    postUserApplications: async () => {
        try {
            const response = await customFetch('usersApplications', {
                method: "POST"
            });

            if (response) {
                return response;
            }
            return null;
        } catch (error) {
            console.error("Error logging out:", error);
            return null;
        }
    }
});